<!--section about us-->
<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="row" style="height:420px;padding-top: 75px;">
                    <div class="col-md-12" style="padding-left: 0px;">                        
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1762.1269095894306!2d-82.83149964191588!3d27.955511895672494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2f730b7df9b87%3A0xb54f231aa40f0e76!2s1170%20Gulf%20Blvd%20APT%201403%2C%20Clearwater%2C%20FL%2033767%2C%20USA!5e0!3m2!1sen!2sin!4v1630582196208!5m2!1sen!2sin"
                            width="{{windowwidth}}" height="419" frameborder="0" style="border:0;"
                            allowfullscreen="true" aria-hidden="false" tabindex="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section style="background-color: #F2F3F5;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 pl-5" data-aos="fade-right" style="background-color: white;">
                <h4 style="padding-top:50px;"><strong class="theme_color">Florida Office</strong></h4>
                <p><i class="fa fa-map-marker"></i>&nbsp;&nbsp;1170 Gulf Blvd, Suite 1403, Clearwater, FL 33767</p>                
                <p><i class="fa fa-phone-square"></i>&nbsp;&nbsp;813-867-7200</p>
                <p><i class="fa fa-envelope-o"></i>&nbsp;<a href="mailto:customerservice@sficompliance.com"> customerservice@sficompliance.com</a></p>
                
                <hr/>

                <!-- <h4 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    SFI Compliance is a Proud Member of:
                </h4>

                <a href="https://www.Floridasafety.org" target="_blank"><img data-aos="zoom-in" data-aos-delay="100" src="../../assets/images/CSA-logo-300x143.png" class="img-fluid"/></a><br/>
                <a href="https://www.hbadenver.com" target="_blank"><img data-aos="zoom-in" data-aos-delay="200" src="../../assets/images/HBA-denver-logo-sm.png" class="img-fluid"/></a><br/>
                <a href="https://www.cshba.com/" target="_blank"><img data-aos="zoom-in" data-aos-delay="300" src="../../assets/images/CSHBA-logo-300x102.png" class="img-fluid"/></a><br/>

                <hr/> -->

                <h4 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Don’t miss the latest safety news!
                </h4>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="200">We share important OSHA safety news and updates, useful safety information you can share with your team, and a list of our upcoming Florida safety classes.</p>

                <a role="button" class="btn btn-danger" href="https://visitor.r20.constantcontact.com/manage/optin?v=0017rDYctTjtbhpHTxBvvbPrdbMCpKVTALAHMl1Kd6ARZ3ut4m_I_5dAS0Ba0GRsYdPWr0EKA-U0cVqSVYFZa1fYGmfGSoS8l4SLImJWT82kDm-hifk4CfeVPlsp9Ga520POQFMK2VYN-6djPNOB0UEALfmi_NFJkfxzyPjSaPHQRAku9390UNYkqaEaq6R8TLf">SIGN UP NOW!</a>
            </div>

            <div class="col-lg-8 pl-5" data-aos="fade-left">
                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100" style="padding-top:50px;">
                    Your Full-Service Florida Jobsite Safety Company.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">Our full-service, bilingual safety consulting firm now has a location in Tampa Bay! We provide safety consulting and services to all of Florida, focusing on Tampa Bay and Orlando. From the boardroom to your Florida job site, our safety team works with your team to keep everyone safe!</p>

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Florida Workplace Safety Data and Reports.
                </h3>

                <span class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    Keep your Florida workforce safe - in 2019 there were 306 work related fatalities in Florida, that is almost one every day.
                </span>


                <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">                    
                    <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;<a href="https://www.bls.gov/news.release/pdf/cfoi.pdf" target="_blank">Bureau of Labor Statistics Report</a></li>
                </ul><br/>

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    SFI specializes in:
                </h3>

                <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                    <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Multi-Family Residential (Apartments)</li>
                    <li data-aos="fade-up" data-aos-delay="200"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Home Building – Single Family and Multi-Family</li>
                    <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Commercial Construction</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Heavy Highway Construction</li>
                    <li data-aos="fade-up" data-aos-delay="500"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Bridge Construction</li>
                    <li data-aos="fade-up" data-aos-delay="600"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Commercial Manufacturing</li>
                    <li data-aos="fade-up" data-aos-delay="700"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;General Industry</li>
                </ul><br/>

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    SFI Compliance –your jobsite safety partner in Florida!
                </h3>

                <ul class="theme_color fontSize" data-aos="fade-up" data-aos-delay="100">
                    <li data-aos="fade-up" data-aos-delay="100"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Over 100 years of workplace safety and risk management experience</li>
                    <li data-aos="fade-up" data-aos-delay="200"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Industry recognition for excellence</li>
                    <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Extensive bilingual capabilities</li>
                    <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-circle fontRed facirclesize"></i>&nbsp;Advanced certifications</li>
                </ul><br/>

                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Florida Safety Programs.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    For over 30 years we have kept businesses OSHA-Compliant through our safety programs. With our customized safety plans you can retain top employees and gain new customers. SFI Compliance will work with you to either write a new safety program, or review and revise your Florida company’s existing written safety program to ensure it meets OSHA standards and requirements.
                </p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    A well-managed safety program provides real protection for your workers and your business - find out more about our <a href="/safetyprogram">Safety Programs</a>.
                </p>


                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Florida Onsite Safety Training.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    SFI’s experienced safety instructors are approved to train by the US Department of Labor! They will travel to your location and provide on-site safety training for your Florida company. Our comprehensive training programs are designed to train your teams to stay safe! When you partner with us, your OSHA training program can result in fewer injuries and illnesses, better morale and lower workers’ compensation insurance premiums, among other benefits.
                </p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    SFI provides custom-tailored OSHA safety training programs based on your company’s needs - find out more about our <a href="/safetytraining">Safety Training</a>.
                </p>


                <h3 class="theme_color" data-aos="fade-up" data-aos-delay="100">
                    Florida Jobsite Safety Inspections.
                </h3>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    Do you know what OSHA looks for when they do a safety inspection? Waiting for an OSHA inspection to occur is not the best approach to find out if your company is in compliance! You may be putting your employees at risk and your company in jeopardy of high fines. Our Florida safety inspection team will do a thorough inspection designed to identify safety hazards that will ultimately prevent injuries and accidents.
                </p>

                <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                    We know what OSHA looks for! Keep your Florida company safe and OSHA-Compliant – find out more about our <a href="/safetyinspection">Safety Inspections</a>.
                </p>
            </div>
        </div>
    </div>
</section>